import React, { Component, useMemo } from 'react'
import { useIonAlert } from '@ionic/react';
import { v4 as uuidv4 } from 'uuid'
import { bindActionCreators } from '@reduxjs/toolkit'
import { connect } from 'react-redux'
import methods from '../reducers/methods'
import * as ConfigActions from '../reducers/config'
import * as UserActions from '../reducers/user'
import * as SurveyActions from '../reducers/survey'
import * as BotProfileActions from '../reducers/botProfile'
import CustomTheme from '../components/CustomTheme'
import {
    Grid,
    Typography,
    Drawer,
    Toolbar,
    Divider,
    Box,
    Stack,
    CssBaseline,
    List,
    ListItem
} from '@mui/material'
import AppNavigator2 from '../components/AppNavigator2'
import * as Buttons from '../components/UIComponents/Button'
import SendPanel from './ChatRoom/SendPanel'
import OptionPanel from './ChatRoom/OptionPanel'
import ChatWindow from './ChatRoom/ChatWindow'
import BotHelper from '../helpers/BotHelper'
import { withRouter } from 'react-router';
import * as Images from '../components/UIComponents/Images'
import config from '../config/config'
import moment from 'moment'
import ChatHelper from '../helpers/ChatHelper'
import { defaultLang } from '../lang/init'

import { IonSelect, IonSelectOption, IonItem, IonLabel, IonContent } from '@ionic/react';
import AuthenticationHelper from '../helpers/AuthenticationHelper'
import UserProfileHelper from '../helpers/UserProfileHelper'
import GeneralHelper from '../helpers/GeneralHelper';
let { innerWidth, innerHeight } = window

let INNERWIDTH = innerWidth >= 600 ? 600 : innerWidth

/***
{
    "answer": "この文脈では、タバコの喫煙は心房細動のリスクを増加させることが示唆されています。喫煙は健康に悪影響を及ぼすため、一般的にはおすすめされません。喫煙をやめることは、心房細動のリスクを減らすための重要なステップです。ただし、具体的な喫煙の量や期間によるリスクの関係については、さらなる研究が必要です。",
    "chat_history": [],
    "question": "タバコはどうな程度をおすすめますか？",
    "source_documents": [
        {
            "lc_attributes": {},
            "lc_namespace": [
                "langchain",
                "schema",
                "document"
            ],
            "lc_secrets": {},
            "lc_serializable": false,
            "metadata": {
                "page": 23,
                "source": "newPaper3.pdf"
            },
            "page_content": "for ever smokers (current and former smokers com-\nbined) and lowest for former smokers.\nThe present systematic review and meta-analysis has\nsome limitations that need to be discussed. Smokerstend to have a less healthy overall lifestyle than non-\nsmokers, with more abdominal obesity, less physical\nactivity, higher intake of alcohol and unhealthier dietsthan non-smokers. We found that the results persistedamong studies that adjusted for adiposity and physicalactivity (ever smokers), although no studies adjustedfor dietary factors; however, little is known aboutthe relationship between diet and atrial ﬁbrillation.There was some indication of heterogeneity by adjust-\nment for alcohol, with no association among the few\nstudies with such adjustment; however, further studiesare needed to clarify if this really is due to adjustmentfor alcohol or if it is due to chance or a study-speciﬁceﬀect because there were few studies with such adjust-ment. Residual confounding by other risk factors thanthose included in the multivariable models of the origi-nal studies can also not be ruled out. Although tobacco\nsmoking was self-reported and there may be somemeasurement errors in the assessment of tobacco smok-\ning, validation studies using urinary cotinine as a refer-ence biomarker have shown high correlations between\nself-reported smoking status and the biomarker.\n45,46\nMisclassiﬁcation of the outcome is also a possibility;\nhowever, in several subgroup analyses we found no sig-niﬁcant heterogeneity in the results between studies thatused only hospital discharge linkages to identify casesand studies that used multiple sources (self-report, hos-pital or medical record linkage, electrocardiograms) toidentify the cases, with or without outcome adjudication\nor validation.\nThere was high heterogeneity in the analysis of cur-\nrent and ever smokers and there was some variation inthe results, with a few studies showing no clear relationwhile others found 50–100% increases in the RR,but we did not ﬁnd a clear explanation for this hetero-geneity in the subgroup analyses. It is possible that dif-ferent intensities and durations of tobacco smoking\ncould contribute to such heterogeneity, which then\nmight not be captured by a simple analysis of onlysmoking status. There was little or no heterogeneityobserved in the analysis of former smokers as well asin the analysis of cigarettes per day, but there was also alimited number of studies included in the dose–responseanalysis. Further studies with more in-depth analyses ofnumber of cigarettes per day, duration, pack-years and\ntime since smoking cessation are needed. It is also pos-\nsible that residual confounding by passive smokingamong the never smokers may have diluted an eﬀectof smoking on atrial ﬁbrillation; however, no prospect-ive data on passive smoking and atrial ﬁbrillation wereavailable.\nThe dose–response relationship between smoking\nand the risk of atrial ﬁbrillation may suggest that\nthere is an underlying biological relationship thatCigarettes per day and atrial fibrillation, per 10 cig/d \n Relative Risk .5  .75  1  1.5  2  3 Study Relative Risk\n (95% CI)\n Kokubo, 2017   1.11 ( 1.00, 1.23)\n Rosengren, 2009   1.16 ( 1.11, 1.22)\n Heeringa, 2008   1.05 ( 0.89, 1.24)\n Overall   1.14 ( 1.10, 1.20)\n11.52RR\n0 5 10 15 20 25 30\nCigarettes per dayBest fitting cubic spline\n95% confidence intervalNonlinear analysis of cigarettes per day and atrial fibrillationCigarettes per day and atrial fibrillation, \nnonlinear dose-response analysis(a)\n(b)\nFigure 3. Cigarettes per day and atrial fibrillation, linear dose-\nresponse analysis per 10 cigarettes per day (a) and non-linear\ndose-response analysis (b). Relative risk .5  .75  1  1.5  2  3 Study Relative risk\n (95% CI)\n Perkiomaki, 2017   1.10 ( 1.00, 1.22)\n Chamberlain, 2011   1.19 ( 1.14, 1.24)\n Overall   1.16 ( 1.09, 1.25)\nFigure 4. Pack-years and atrial fibrillation, dose–response per"
        },
        {
            "lc_attributes": {},
            "lc_namespace": [
                "langchain",
                "schema",
                "document"
            ],
            "lc_secrets": {},
            "lc_serializable": false,
            "metadata": {
                "page": 28,
                "source": "newPaper3.pdf"
            },
            "page_content": "60. Goette A, Lendeckel U, Kuchenbecker A, et al. Cigarette\nsmoking induces atrial fibrosis in humans via nicotine.Heart 2007; 93: 1056–1063.\n61. Shan H, Zhang Y, Lu Y, et al. Downregulation of miR-\n133 and miR-590 contributes to nicotine-induced atrialremodelling in canines. Cardiovasc Res 2009; 83: 465–472.Aune et al. 1451Downloaded from https://academic.oup.com/eurjpc/article/25/13/1437/5926280 by guest on 17 July 2023"
        },
        {
            "lc_attributes": {},
            "lc_namespace": [
                "langchain",
                "schema",
                "document"
            ],
            "lc_secrets": {},
            "lc_serializable": false,
            "metadata": {
                "page": 115,
                "source": "newPaper3.pdf"
            },
            "page_content": "30,166–168\nA meta-analysis found a dose-dependent relationship \nbetween smoking and AF risk that was most prominent in \nactive compared with former smokers.169\nChronic obstructive pulmonary disease is an independent \nrisk factor for AF.170\nSmoking negatively affects the efficacy of AF ablation.171No specific data on AF are reported in targeted smoking cessation other than as part of general lifestyle and risk \nfactor modification trials that report reductions in AF \nburden.Smoking cessation support and \ncounseling are \nrecommended in \nan AF prevention \nstrategy.\nAlcohol Alcohol may serve as both a trigger and sustainer of AF via \natrial remodeling and autonomic effects.\n172–176\nThe Norwegian HUNT Study showed a curvilinear association \nbetween alcohol and the risk of AF, almost no increase in risk \nwith ≤7 drinks/wk, but risk increased significantly with >14 \ndrinks/wk. There was no demonstrated risk for  ≤1 drink/d for \nwomen and 2 drinks/d for men.177A recent RCT reported that abstinence from alcohol \nintake in patients with AF drinking ≥10 drinks/wk was \nassociated with improved AF rhythm control compared \nwith control.178 Alcohol use was reduced from 16.8±7.7 \nto 2.1±3.7 drinks/wk (87.5% reduction) in the \nabstinence group and 16.4±6.9 to 13.2±6.5 drinks/wk \n(19.5%) in the control group. AF recurred in 53% and \n73% of the abstinence and control groups, respectively, \nwith longer time to recurrence in the abstinence group \n(HR, 0.55; 95% CI, 0.36–0.84; P=0.005) and lower \nAF burden over 6 mo of follow-up (median 0.5% [IQR 0.0–3.0] vs 1.2% [IQR 0.0–10.3], P=0.01).Patients with AF who regularly consume \nmoderate or high \nlevels of alcohol should be counseled \nto reduce their intake.\n(Continued)\nDownloaded from http://ahajournals.org by on February 26, 2023"
        },
        {
            "lc_attributes": {},
            "lc_namespace": [
                "langchain",
                "schema",
                "document"
            ],
            "lc_secrets": {},
            "lc_serializable": false,
            "metadata": {
                "page": 14,
                "source": "newPaper3.pdf"
            },
            "page_content": "Review\nT obacco smoking and the risk of\natrial fibrillation: A systematic review\nand meta-analysis of prospective studies\nDagfinn Aune1,2,3, Sabrina Schlesinger4, T eresa Norat1\nand Elio Riboli1\nAbstract\nBackground: Epidemiological studies on smoking and atrial fibrillation have been inconsistent, with some studies\nshowing a positive association while others have found no association. It is also unclear whether there is a dose–response relationship between the number of cigarettes smoked or pack-years and the risk of atrial fibrillation.We conducted a systematic review and meta-analysis to clarify the association.Design: Systematic review and meta-analysis.\nMethods: We searched the PubMed and Embase databases for studies of smoking and atrial fibrillation up to 20 July\n2017. Prospective studies and nested case–control studies within cohort studies reporting adjusted relative risk esti-mates and 95% confidence intervals (CIs) of atrial fibrillation associated with smoking were included. Summary relativerisks (95% CIs) were estimated using a random effects model.Results: T wenty nine prospective studies (22 publications) were included. The summary relative risk was 1.32 (95% CI\n1.12–1.56, I\n2¼84%, n¼11 studies) for current smokers, 1.09 (95% CI 1.00–1.18, I2¼33%, n¼9) for former smokers\nand 1.21 (95% CI 1.12–1.31, I2¼80%, n¼14) for ever smokers compared to never smokers. Comparing current versus\nnon-current smokers the summary relative risk was 1.33 (95% CI 1.14–1.56, I2¼78%, n¼10). The summary relative risk\nwas 1.14 (95% CI 1.10–1.20, I2¼0%, n¼3) per 10 cigarettes per day and 1.16 (95% CI 1.09–1.25, I2¼49%, n¼2) per\n10 pack-years and there was no evidence of a non-linear association for cigarettes per day, Pnon-linearity ¼0.17.\nConclusions: The current meta-analysis suggests that smoking is associated with an increased risk of atrial fibrillation in\na dose-dependent matter, but the association is weaker among former smokers compared to current smokers.\nKeywords\nT obacco, cigarettes, smoking, atrial fibrillation, systematic review, meta-analysis\nReceived 15 August 2017; accepted 13 May 2018\nIntroduction\nAtrial ﬁbrillation is the most common type of arrhyth-\nmia and globally an estimated 5 million incident casesoccurred in 2010,\n1and the prevalence has been esti-\nmated at 33 million in 2015.2The prevalence of atrial\nﬁbrillation has been projected to increase 2.5-fold in thenext 50 years, partly due to an ageing population, butalso due to an increased incidence of the disease.\n3\nSeveral meta-analyses have found positive associationsbetween a diagnosis of atrial ﬁbrillation and the risk ofischaemic heart disease, heart failure, sudden cardiacdeath, stroke, peripheral arterial disease, chronic\nkidney disease and all-cause mortality.\n4,5It has also1Department of Epidemiology and Biostatistics, Imperial College London,\nUK\n2Department of Nutrition, Bjørknes University College, Norway\n3Department of Endocrinology, Morbid Obesity and Preventive Medicine,\nOslo University Hospital, Norway\n4Institute for Biometry and Epidemiology, German Diabetes Center,\nLeibniz Institute for Diabetes Research at Heinrich Heine UniversityDu¨sseldorf, Du ¨sseldorf, Germany\nCorresponding author:\nDagfinn Aune, Department of Epidemiology and Biostatistics, School of\nPublic Health, Imperial College London, St Mary’s Campus, Norfolk Place,London W2 1PG, UK.Email: d.aune@imperial.ac.ukEuropean Journal of Preventive\nCardiology2018, Vol. 25(13) 1437–1451\n!The European Society of\nCardiology 2018Article reuse guidelines:sagepub.com/journals-permissionsDOI: 10.1177/2047487318780435journals.sagepub.com/home/ejpcDownloaded from https://academic.oup.com/eurjpc/article/25/13/1437/5926280 by guest on 17 July 2023"
        }
    ]
}
 */

const chatroomObj = {
    nurse: {
        title: "Ms. OICI",
        sx: {
            color: 'text.light',
            bgcolor: 'background.dark',
            justifyContent: 'center',
            alignItems: 'space-between'
        },
        image: 'nurseImg'

    },
    faqbot: {
        title: "FAQoid",
        sx: {
            color: 'primary.dark',
            bgcolor: 'secondary.main'
        },
        image: 'faqBotImg'
    },
    pdfbot: {
        title: "PDF Chatbot",
        sx: {
            color: 'primary.dark',
            bgcolor: 'background.dark'
        },
        image: 'nurseImg'
    }
}

const AlertHandler = ({ onBackConfirm }) => {
    const [presentAlert] = useIonAlert()
    const handleBackClick = () => {
        presentAlert({
            header: "ログインページに戻る？",
            message: "このチャットを終了してもデータは保存されます。いつでも戻ってきて続きを再開できます。",
            buttons: [
                {
                    text: "キャンセル",
                    role: "cancel",
                },
                {
                    text: "はい",
                    handler: () => {
                        if (onBackConfirm) onBackConfirm();
                    },
                },
            ],
        })
    }

    return (
        <button onClick={handleBackClick} style={{ display: 'none' }} id="hidden-alert-trigger"></button>
    )
}

const botImgObj = {
    faqBotImg: <Images.ChatbotPointerRight />,
    nurseImg: <Images.NursePointerRight />
}
// const safeTop = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--sat").replace("px"), 10) || 0
// const safeBottom = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--sab").replace("px"), 10) || 0
const safeTop = 0
const safeBottom = 0
// console.log("the safe top is ",safeTop, " and the safe bottom is ", safeBottom)

const chatInitialState = {
    inputMessage: "",
    messageThread: [],
    chatbotVersion: '',
    whichBot: 'nurse',
    chatbotOptions: [], // Initialize chatbotOptions as an empty array
    chatbotOptionType: '',
    qIndex: -1, // Initialize qIndex with -1 or any other default value
    qObj: {},
    chatWindowWidth: INNERWIDTH,
    chatHeaderHeight: config.headerHeight,
    disableAnswer: false
}
class ChatRoom extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ...chatInitialState,
            selectedBotId: "9d6c1d9b-1234-4f6d-93a8-4567bcde1234",
            conversation_id: uuidv4() // Generate a unique conversation ID for the session
        };
        this.updateDimensions = this.updateDimensions.bind(this)
        this.updateMessage = this.updateMessage.bind(this)
        this.addMessage = this.addMessage.bind(this)
        this.determineNextQuestion = this.determineNextQuestion.bind(this)
        this.onResponseCallback = this.onResponseCallback.bind(this)
        this.triggerTimedResponse = this.triggerTimedResponse.bind(this)
        this.onReturn = this.onReturn.bind(this)
        this.onRestart = this.onRestart.bind(this)
        this.onBotQueryWithPath = this.onBotQueryWithPath.bind(this)
        this.addUrl = this.addUrl.bind(this)
        this.handleBotSelection = this.handleBotSelection.bind(this); // Bind the function
        this.onRequestEditBotProfile = this.onRequestEditBotProfile.bind(this)
    }

    async componentDidMount() {
        // console.log("chatroom loaded")
        const { match, location, user, configReducer, switchLanguage, survey, clearSurvey, chatbotProfile, loadProfile, history } = this.props
        const { messageArr, currentIndex } = survey
        const { dict, bot, lang } = configReducer
        const { selectedBotId, conversation_id } = this.state
        
        // console.log("check if user has logged in to the chatroom")
        //user is not logged in. go back!
        if (!AuthenticationHelper.uuid) return history.push("/")
        // initialize the size parameter for chatbot window according to the device dimension
        window.addEventListener('resize', this.updateDimensions);

        const initHeaderElement = document.querySelector('header')
        let initHeaderHeight = initHeaderElement.offsetHeight || config.headerHeight;
        this.setState({
            chatHeaderHeight: initHeaderHeight
        })

        // better the load the language every time logging into the app
        switchLanguage(defaultLang)

        const currentLang = dict["chatWindow"][bot]
        
        // console.log('chat room props', this.props)
        // initialize the chatbot content
        const whichChatbot = match?.params?.subroom || "pdfbot"
        this.setState({
            whichBot: whichChatbot
        })
        let botObj = chatroomObj[whichChatbot]

        const usersBot = await UserProfileHelper.getUserBots(AuthenticationHelper.uuid)
        const targetBot = usersBot[0]
        // console.log("users bot", usersBot)
        this.setState({
            selectedBotId: targetBot
        })


        // get the chatbot profile and load it into redux storage. In case user wants to edit the profile
        const targetBotProfile = await BotHelper.getBotProfileById(this.state.selectedBotId)
        // this will load the bot memory in the backend session so the bot will remember users' previous conversations
        const loadBotMem = await BotHelper.loadBodMem(AuthenticationHelper.uuid, this.state.selectedBotId)
        // console.log("the results of loading bot memory", loadBotMem)
        // console.log("bot profile", targetBotProfile)
        loadProfile({
            id: this.state.selectedBotId,
            profileObj: targetBotProfile['data']
        })

        // if (messageArr.length > 0) // there were previous messages, ask if user wishes to continue or restart
        // {

        //     // console.log(typeof messageArr)
        //     let toContinue = window.confirm("入力途中のデータがあるようです。前回の続きから再開しますか？")
        //     // console.log("user wishes not to restart", toContinue)
        //     if (toContinue) {
        //         let mutatedArr = [...messageArr]
        //         // mutatedArr.pop()
        //         this.setState({
        //             messageThread: mutatedArr
        //         })
        //         return
        //     }
        //     //user wishes to restart, clear the input
        //     await clearSurvey()
        //     this.setState({
        //         messageThread: []
        //     })
        // }
        // get the previous chat log of the same user
        const chatlogs = await ChatHelper.getChatLogByUserId(AuthenticationHelper.uuid)
        // console.log("user's chat log is ,", chatlogs)
        if(chatlogs.length > 0)
        {
            let mutateedMessages = []
            // parse the chatlot
            await GeneralHelper.asyncForEach(chatlogs,  async (e, idx) => {
                if(idx === 0) return;
                // console.log(`idx of ${idx} is `, e)
                let answerObj = {
                    message: e?.message_content,
                    source: e?.message_role,
                    time: e?.timestamp
                    // image: botImgObj[botObj["image"]]
                }
                // console.log("try to get bot image", botObj)
                answerObj["image"] = botImgObj[botObj["image"]]
                mutateedMessages.push(answerObj)
            })
            this.setState({
                messageThread: mutateedMessages
            })
            return 
        }
        else
        {
            // after defining the target bot, generate the initial greeting to the user.
            const botAnswer2 = await BotHelper.queryPdfBot(`Hello, user enters the chat room. Can you greet ${user?.gender === "Male" ? 'him' : 'her'} politely by calling  ${user?.gender === "Male" ? 'his' : 'her'} name?`, targetBot, conversation_id, AuthenticationHelper.uuid); // Pass conversation_id

            if (botAnswer2?.response?.answer_text) {
                await this.addMessage(botAnswer2?.response?.answer_text, "bot");
            }
            return
        }

    }
    componentWillUnmount() {
        // console.log("component unmountingggggg")
        // this.handleBackConfirm()
        window.removeEventListener('resize', this.updateDimensions);
    }
    updateDimensions() {
        // console.log("window resizing", window.innerWidth)
        const headerElement = document.querySelector('header')
        let headerHeight = headerElement.offsetHeight;
        // console.log(headerHeight)
        this.setState({
            chatWindowWidth: window.innerWidth >= 600 ? 600 : window.innerWidth,
            chatHeaderHeight: headerHeight
        })
    }

    async onRequestEditBotProfile() {
        // 1. check if redux has bot profile
        // 2. parse the special sections
        // 3. redirect to the /profilesetup page
        const { botProfile, loadProfile, history } = this.props
        // console.log("request to edit bot profile", botProfile)

        // return
        // check if bot profile has all the sections needed, if not, reload the same id
        if (botProfile.hasOwnProperty("id") && botProfile.id !== ""
            && botProfile.hasOwnProperty("profileObj") && Object.keys(botProfile.profileObj).length > 0
        ) {
            // parse the background, story, personality, responseStyle, symptomsAndBehaviours
            let newBotProfileObj = { ...botProfile["profileObj"] }
            if (botProfile["profileObj"].hasOwnProperty("background") && botProfile["profileObj"].background !== "") {
                try // in case the profile is stored in a wrong format
                {
                    newBotProfileObj["backgroundObj"] = BotHelper.paresYmlString(botProfile["profileObj"]["background"])
                }
                catch (e) {
                    // console.log("parse error")
                    newBotProfileObj["backgroundObj"] = []
                }
            }
            if (botProfile["profileObj"].hasOwnProperty("story") && botProfile["profileObj"].story !== "") {
                try // in case the profile is stored in a wrong format
                {
                    newBotProfileObj["storyObj"] = BotHelper.paresYmlString(botProfile["profileObj"]["story"])
                }
                catch (e) {
                    // console.log("parse error")
                    newBotProfileObj["storyObj"] = []
                }
            }
            if (botProfile["profileObj"].hasOwnProperty("personality") && botProfile["profileObj"].personality !== "") {
                try // in case the profile is stored in a wrong format
                {
                    newBotProfileObj["personalityObj"] = BotHelper.paresYmlString(botProfile["profileObj"]["personality"])
                }
                catch (e) {
                    // console.log("parse error")
                    newBotProfileObj["personalityObj"] = []
                }
            }
            if (botProfile["profileObj"].hasOwnProperty("symptomsAndBehaviours") && botProfile["profileObj"].symptomsAndBehaviours !== "") {
                try // in case the profile is stored in a wrong format
                {
                    newBotProfileObj["symptomsAndBehavioursObj"] = BotHelper.paresYmlString(botProfile["profileObj"]["symptomsAndBehaviours"])

                }
                catch (e) {
                    // console.log("parse error")
                    newBotProfileObj["symptomsAndBehavioursObj"] = []
                }
            }
            if (botProfile["profileObj"].hasOwnProperty("responseStyle") && botProfile["profileObj"].responseStyle !== "") {
                try // in case the profile is stored in a wrong format
                {
                    newBotProfileObj["responseStyleObj"] = BotHelper.paresYmlString(botProfile["profileObj"]["responseStyle"])

                }
                catch (e) {
                    // console.log("parse error")
                    newBotProfileObj["responseStyleObj"] = []
                }
            }
            // console.log("parsed bot profile",newBotProfileObj)
            // botProfile["profileObj"] = newBotProfileObj
            // load the newly parsed bot data

            // add edit flag
            newBotProfileObj["isEditProfile"] = true
            // console.log("load profile checkpoint", newBotProfileObj)
            loadProfile({
                id: botProfile["id"],
                profileObj: newBotProfileObj
            })
            // console.log("should redirect to profile setup")
            // redirect to the profile setup page
            history.push("/profilesetup")
        }
        // add alert
        return

    }

    async updateMessage(value) {
        // console.log("user input messages", value)
        this.addMessage(value, "user");
        const { match } = this.props;
        const { selectedBotId, conversation_id } = this.state; // Get conversation_id from state
        const { chatbotOptions, qIndex } = this.state; // Add this line to extract chatbotOptions and qIndex from the state
        const whichChatbot = match?.params?.subroom || "nurse";
        // console.log("what is used ", whichChatbot)
        // console.log("the selected bot is ", selectedBotId)
        switch (whichChatbot) {
            // case "faqbot":
            //     const botAnswer = await BotHelper.queryBot(value, selectedBotId, conversation_id, AuthenticationHelper.uuid); // Pass conversation_id
            //     // console.log("bot answered", botAnswer);
            //     if (botAnswer?.response?.answer_text) {
            //         await this.addMessage(botAnswer?.response?.answer_text, "bot");
            //     }
            //     if (botAnswer?.response?.asnwer_text) {
            //         await this.addMessage(botAnswer?.response?.asnwer_text, "bot");
            //     }
            //     if (botAnswer?.response?.path_url) {
            //         await this.onBotQueryWithPath(botAnswer?.response?.path_url);
            //     }
            //     if (botAnswer?.body) {
            //         await this.addMessage(botAnswer?.body, "bot");
            //     }
            //     return;
            case "pdfbot":
                // console.log("currently using pdf bot")
                const botAnswer2 = await BotHelper.queryPdfBot(value, selectedBotId, conversation_id, AuthenticationHelper.uuid); // Pass conversation_id

                if (botAnswer2?.response?.answer_text) {
                    await this.addMessage(botAnswer2?.response?.answer_text, "bot");
                }
                // this function below is for capturing the type in the key. It's no longer needed (probably)
                // if (botAnswer2?.response?.asnwer_text) {
                //     await this.addMessage(botAnswer2?.response?.asnwer_text, "bot");
                // }
                {/** The whole section below is for paper GPT
                if (botAnswer2?.response?.answer) {
                    if (botAnswer2?.response?.source_documents && botAnswer2?.response?.source_documents.length > 0) {
                        // console.log("extra info provided");
                        let sourceDocArr = [];
                        botAnswer2?.response?.source_documents.map((doc, idx) => {
                            try {
                                const docName = doc?.metadata?.source;
                                const pageNo = doc?.metadata?.page;
                                const pageContent = doc?.page_content;

                                sourceDocArr.push({
                                    sourceFile: docName,
                                    page: pageNo,
                                    pageContent: pageContent
                                });
                            } catch (e) {
                                console.log(e);
                            }
                        });
                        await this.addMessage(botAnswer2?.response?.answer, "bot", sourceDocArr);
                    } else {
                        await this.addMessage(botAnswer2?.response?.answer, "bot");
                    }
                }
                if (botAnswer2?.response?.path_url) {
                    await this.onBotQueryWithPath(botAnswer2?.response?.path_url);
                }
                if (botAnswer2?.body) {
                    await this.addMessage(botAnswer2?.body, "bot");
                }
                */}
                return;
            default: // in the case of nurse bot, the value should be the question index
                let nextOption = chatbotOptions["1"]?.next_index || qIndex + 1;
                return this.onResponseCallback(parseInt(nextOption, 10), "bot");
        }
    }

    addMessage(msg, src, extraInfo = null) {
        const { match, location, survey, addAnswer } = this.props
        const { messageArr } = survey
        // console.log("add extra info", extraInfo)
        const whichChatbot = match?.params?.subroom || "nurse"
        // console.log("the default bot is ",whichChatbot)
        let botObj = chatroomObj[whichChatbot]
        let mutedMsg = [...this.state.messageThread]
        // console.log("received bot option", botObj)

        if (extraInfo) {
            let answerObj = {
                message: msg,
                source: src,
                // time: moment(),
                image: botImgObj[botObj["image"]],
                extraInfo: extraInfo
            }
            mutedMsg.push(answerObj)
            answerObj["image"] = botObj["image"]
            addAnswer(answerObj)
            // console.log(mutedMsg)
            this.setState({
                messageThread: mutedMsg
            })
            return
        }
        let answerObj = {
            message: msg,
            source: src,
            // time: moment(),
            image: botImgObj[botObj["image"]]
        }
        mutedMsg.push(answerObj)
        answerObj["image"] = botObj["image"]
        addAnswer(answerObj)
        // console.log(mutedMsg)
        this.setState({
            messageThread: mutedMsg
        })
        return
    }

    async determineNextQuestion(answerIndex = 0) {
        const {
            chatbotOptionType,
            chatbotOptions,
            qObj,
            qIndex
        } = this.state
        try {
            const answerKey = answerIndex.toString()
            const nextQuestionIndex = chatbotOptions.hasOwnProperty(answerKey) ? chatbotOptions[answerKey]?.next_index : qIndex + 1
            return nextQuestionIndex
        }
        catch (e) {
            return -1
        }
    }

    onReturn() {
        const { history } = this.props
        this.setState(chatInitialState)
        history.push("/")
    }

    onRestart() {
        this.setState(chatInitialState)
        this.onResponseCallback("0", "bot")
        // this.setState({
        //     qIndex: 0,
        //     messageThread: []
        // })
    }

    // for NCC bot, if there are paths, then render the path
    async onBotQueryWithPath(pathUrl = {}) {
        if (Object.keys(pathUrl).length <= 0) return
        // console.log(pathUrl)
        this.addUrl(pathUrl, "bot")
        return
    }

    async addUrl(msg, src) {
        const { match, location } = this.props
        const whichChatbot = match?.params?.subroom || "faqbot"
        // console.log("the default bot is ",whichChatbot)
        let botObj = chatroomObj[whichChatbot]
        let mutedMsg = [...this.state.messageThread]
        // console.log("received bot option", botObj)
        mutedMsg.push({
            message: msg,
            source: src,
            // time: moment(),
            image: botImgObj[botObj["image"]]
        })
        // console.log(mutedMsg)
        this.setState({
            messageThread: mutedMsg
        })
    }

    async onResponseCallback(qIndex = 0, src) {
        const { match } = this.props;
        const { conversation_id } = this.state; // Get conversation_id from state

        this.setState({ disableAnswer: true });

        const nextQ = await BotHelper.querySurveyBot(qIndex, conversation_id); // Pass conversation_id
        if (nextQ && typeof nextQ === "string") {
            this.addMessage("Survey is completed, thanks for your contribution!", src);
            this.setState({ disableAnswer: false });
            return;
        }

        if (nextQ?.type === "display") {
            let nextIndex = nextQ?.options["1"]["next_index"] || nextQ?.survey_index + 1;
            this.triggerTimedResponse(nextIndex);
        }
        this.addMessage(`${nextQ?.qID} ${nextQ?.qDesc}`, src);
        setTimeout(() => {
            this.setState({
                chatbotOptionType: nextQ?.type,
                chatbotOptions: nextQ?.options,
                qIndex: nextQ?.survey_index || -1,
                qObj: nextQ,
                disableAnswer: false
            });
        }, config.typingLatency);
    }

    triggerTimedResponse(qIndex = null) {
        if (!qIndex) return
        setTimeout(() => {
            this.onResponseCallback(qIndex, "bot")
        }, 1500)
    }

    handleBotSelection = (botId) => {
        this.setState({ selectedBotId: botId, messageThread: [], conversation_id: uuidv4() }); // Clear chat log and create a new conversation ID
    };

    clearChatLog = () => {
        this.setState({ messageThread: [] }); // Reset the chat log
    };

    handleBackConfirm = () => {
        const { history, resetSession } = this.props
        this.clearChatLog()
        this.setState({
            ...chatInitialState
        })
        history.push('/')
        resetSession()
    }

    triggerAlert = () => {
        const alertTrigger = document.getElementById('hidden-alert-trigger');
        if (alertTrigger) {
            alertTrigger.click()
        }
    }

    render() {

        const {
            messageThread,
            chatbotVersion,
            chatbotSelect,
            whichBot,
            chatbotOptionType,
            chatbotOptions,
            qObj,
            qIndex,
            chatWindowWidth,
            disableAnswer,
            chatHeaderHeight,
            sourceInfoActive
        } = this.state

        const { configReducer, user, resetSession, history, chatbotProfile } = this.props
        const { lang, dict, bot } = configReducer
        // console.log("chatbot profile", chatbotProfile)
        // console.log("test", bot)
        const botLang = dict["chatWindow"][bot]
        // console.log("chatbot options", chatbotOptionType)
        // console.log(`current qindex is ${qIndex}`)
        
        const { selectedBotId } = this.state;

        let shouldSendPanelDisplay = true
        if (chatbotOptions && Object.keys(chatbotOptions).length > 0 && !chatbotOptionType.includes('text')) {
            shouldSendPanelDisplay = false
        }
        if (qObj?.type === "datepick") {
            shouldSendPanelDisplay = false
        }
        let botObj = chatroomObj[whichBot]
        let chatWrapperHeight = innerHeight - chatHeaderHeight - safeTop - safeBottom
        let chatwindowHeight = innerHeight - chatHeaderHeight - config.sendPanelHeight - safeTop - safeBottom
        if (!shouldSendPanelDisplay) {
            chatwindowHeight = innerHeight - chatHeaderHeight - config.optionPanelHeight - safeTop - safeBottom
        }

        // console.log("the chatwindow height is ", chatwindowHeight, " and the chat warpper height is ", chatWrapperHeight)
        return <CustomTheme>
            <AlertHandler onBackConfirm={this.handleBackConfirm} /> 
            <AppNavigator2
                title={chatbotProfile?.profileObj?.name}
                sx={botObj["sx"]}
                // image={botImgObj[botObj["image"]]}
                onBackClicked={() => {
                    // const toConfirm = true
                    this.triggerAlert()
                    return false
                }}
            >
                <Buttons.OutlinedButton onClick={this.onRequestEditBotProfile}>{botLang["edit"]}</Buttons.OutlinedButton>
            </AppNavigator2>

            <Box
                sx={{
                    flexGrow: 1,
                    width: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                    bgcolor: 'background.default',
                    height: chatWrapperHeight
                    // pt: 2
                }}
            >


                <Grid container
                    direction="column"
                    justifyContent="space-between"
                    // alignItems="flex-end"
                    sx={{
                        flexGrow: 1,
                        flexWrap: "wrap",
                        // width: 1,
                        maxWidth: chatWindowWidth,
                        bgcolor: 'background.default',
                        ml: 'auto',
                        mr: 'auto',
                        // borderRadius: 4,

                        // minHeight: chatWrapperHeight,
                        // maxHeight: chatWrapperHeight,
                        // minHeight: `${innerHeight - config.headerHeight}px`, // deduct header and chat
                        // maxHeight: `${innerHeight - config.headerHeight}px`,
                        // py: 2
                        // height: '100vh'
                    }}
                    style={{
                        // paddingTop: `env(safe-area-inset-top)`,
                        // paddingLeft: `env(safe-area-inset-left)`,
                        // paddingRight: `env(safe-area-inset-right)`,
                        // paddingBottom: `env(safe-area-inset-bottom)`,
                    }}
                >
                    <Grid item
                        sx={{
                            // flexGrow: 1,
                            minHeight: `${chatwindowHeight}px`, // deduct header and chat
                            maxHeight: `${chatwindowHeight}px`,
                            overflow: 'auto',
                        }}
                    >
                        <ChatWindow
                            messageArr={messageThread}
                        />
                    </Grid>

                </Grid>

                {!disableAnswer && <Box
                    sx={{
                        position: 'absolute',
                        bottom: shouldSendPanelDisplay ? config.sendPanelHeight : 0,
                        bgcolor: 'background.gray',
                        maxWidth: 1,
                        mr: 'auto',
                        ml: 'auto',
                        right: 0,
                        left: 0
                    }}
                >
                    <Box
                        sx={{
                            position: 'relative',
                            bottom: shouldSendPanelDisplay ? config.sendPanelHeight : 0,
                            maxWidth: chatWindowWidth,
                            mr: 'auto',
                            ml: 'auto',
                            // right: 0,
                            // left: 0
                        }}
                    >
                        <OptionPanel
                            options={chatbotOptions}
                            type={chatbotOptionType}
                            qIndex={qIndex}
                            qObj={qObj}
                            optionClickHint={botLang["Click above to confirm and send"]}
                            optionSubmitHint={botLang["Please select"]}
                            onSubmit={async (optionsArr, nextQuestionIndex, answer, surveyType) => {
                                if (surveyType === "COMPLETE") // determine the next action
                                {
                                    // console.log(answer)
                                    switch (answer) {
                                        case "restart":
                                            this.onRestart()
                                            break
                                        case "return":
                                        default:
                                            this.onRestart()
                                            this.onReturn()
                                    }
                                    return
                                }

                                // add the answer to user
                                // console.log(answer)
                                this.addMessage(answer, "user")
                                let toBeStoredObj = {
                                    qID: qObj?.qID,
                                    surveyIndex: qObj?.survey_index,
                                    answer: JSON.stringify(optionsArr)
                                }
                                // console.log(toBeStoredObj)
                                // handle save the answer in the database
                                const saveResult = await ChatHelper.storeChatLogByUserId(user?.id, user?.sessionId, JSON.stringify(toBeStoredObj))
                                // console.log("saved result", saveResult)
                                // determine the next question
                                // this.determineNextQuestion(nextQuestionIndex)
                                // handle get next question
                                // console.log(`the next question index is ${nextQuestionIndex}`)
                                const updateQuestion = await this.onResponseCallback(nextQuestionIndex, "bot")
                            }}
                        />
                    </Box>
                </Box>}
                {shouldSendPanelDisplay && !disableAnswer && <SendPanel
                    // options={chatbotOptions}
                    // type={chatbotOptionType}
                    // qIndex={qIndex}
                    // qObj={qObj}
                    sendMessage={this.updateMessage}
                />}
            </Box>

        </CustomTheme>
    }
}

// export default withRouter(ChatRoom)

let ChatRoomContainer = props => {
    const { dispatch, user, config, botProfile } = props

    const boundActionCreators = useMemo(() => bindActionCreators({
        ...UserActions,
        ...ConfigActions,
        ...SurveyActions,
        ...BotProfileActions,
        resetSession: methods.RESET_SESSION
    }, dispatch), [dispatch])

    return <ChatRoom
        user={user}
        config={config}
        chatbotProfile={botProfile}
        {...boundActionCreators}
        {...props}
    />
}

ChatRoomContainer = connect(state => ({
    user: state.user,
    configReducer: state.config,
    survey: state.survey,
    botProfile: state.botProfile      // Access botprofile from the correct slice of state
}))(ChatRoomContainer)

export default withRouter(ChatRoomContainer)

export { botImgObj }